import React from "react";
import {
  HStack,
  Button,
  ButtonGroup,
  List,
  ListItem,
  Badge,
  Box,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";

import { t } from "@lang/i18n";
import { View } from "@components";

const AnnonceItem = ({ data, key, setShowModalBox, setAnnonceId, isArchived }) => {
  const { contracts, applicants, state, date, fonctions, id } = data;

  // show modal for archive
  const archiveAd = (e) => {
    e.preventDefault()
    if (setShowModalBox && setAnnonceId) {
      setShowModalBox(true);
      setAnnonceId(id);
    }
  };

  const getColorState = (state) => {
    switch (state) {
      case "approved": {
        return {
          color: "green",
          state: "active"
        }
        
      }
      case "pending": {
        return {
          color: "yellow",
          state: "En attente d’approbation"
        }
        
      }
      case "refused": {
        return {
          color: "red",
          state: "Refusée"
        }
        
      }
      case "archived": {
        return {
          color: "gray",
          state: "Archivée"
        }
        
      }
      default:
        return state;
    }
  };

  return (
    <HStack key={key} as={Link}
      to={`/company/annonce/details/${id}`}
      opacity={isArchived ? ".8" : "1"}
      flexDir="row" justifyContent="space-between"
      boxShadow="2px 2px 20px 0px #00000026"
      borderRadius="md" maxWidth={{base: "385px", md: "none"}} w={{md: "385px"}} h="137px" p=".75rem 1.5rem" mb="28px"
    >
      <List fontSize="12px" w="167px">
        <ListItem fontWeight="bold" fontSize="16px" mb="5px"
          color="gray.borderBoxes" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
          {fonctions && fonctions.map(el => el.name).join(', ')}
        </ListItem>
        <ListItem mb="5px">
          <Badge variant="subtle" colorScheme={isArchived ? getColorState("archived").color : getColorState(state).color} borderRadius="2px">
            { isArchived ? 
                getColorState("archived").state :
                  getColorState(state).state
            }
          </Badge>
        </ListItem>
        <ListItem mb="5px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
          {contracts && `Contact: ${contracts.map((el) => el.name).join(', ')}`}
        </ListItem>
        <ListItem mb="5px">
          <Box as="span"> Total postulants: </Box>
          <Box as="span" color="green.main">
            {applicants === 0 ? (
              <Box as="span" letterSpacing="2px" color="gray">
                ---
              </Box>
            ) : (
              applicants
            )}
          </Box>
        </ListItem>
        <ListItem color="gray.borderBoxes" mb="5px">
        {date && `Publié le: ${date}`}
        </ListItem>
      </List>

      <ButtonGroup variant="outline" spacing="0" size="sm" display="flex" flexDir="column" justifyContent="center" h="100%" w="95px" alignItems="flex-end" m="0">
        <View if={!isArchived}>
          <Link to={`/company/annonce/edit/${id}`}>
            <Button bg="green.main" border="1px solid" borderColor="green.main" borderRadius="5px" color="white" w="95px" fontWeight="400" mb="14px"
              _hover={{ bg: "green.light" }}
            >
              { t('global.edit') }
            </Button>
          </Link>

          <Button borderColor="gray.borderBoxes" color="gray.borderBoxes" w="95px" fontWeight="400" mb="14px"
            onClick={archiveAd}
          >
            { t('global.archive') }
          </Button>
        </View>

        <View if={isArchived}>
          <Link to={`/company/annonce/renew/${id}`}>
            <Button bg="green.main" border="1px solid" borderColor="green.main" borderRadius="5px" color="white" w="95px" fontWeight="400" mb="14px"
              opacity={1}
              _hover={{ bg: "green.light" }}
            >
              { t('global.renew') }
            </Button>
          </Link>
        </View>
      </ButtonGroup>
    </HStack>
  );
};

export default AnnonceItem;
